import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    private baseUrl: string = '/api/'; 
    
    constructor(
        private http: HttpClient,
        private angularAuth: AngularFireAuth) {

    }
    
    private async getIdToken(): Promise<string | null> {
        const user = await this.angularAuth.currentUser;
        return user ? await user.getIdToken() : null;
    }

    private async getHeaders(): Promise<HttpHeaders> {
        const token = await this.getIdToken();
        let headers = new HttpHeaders();
        
        if (token) {
            headers = headers.set('Authorization', `Bearer ${token}`);
        }

        return headers;
    }

    async get(url: string) {
        const headers = await this.getHeaders();
        return this.http.get(`${this.baseUrl}${url}`, { headers }).toPromise();
    }

    async post(url: string, body: any) {
        const headers = await this.getHeaders();
        return this.http.post(`${this.baseUrl}${url}`, body, { headers }).toPromise();
    }

    async put(url: string, body: any) {
        const headers = await this.getHeaders();
        return this.http.put(`${this.baseUrl}${url}`, body, { headers }).toPromise();
    }

    async delete(url: string) {
        const headers = await this.getHeaders();
        return this.http.delete(`${this.baseUrl}${url}`, { headers }).toPromise();
    }
}